module.exports = __webpack_public_path__ + "static/img/dingtalk.9eb5814.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/dingtalk.png
// module id = JUS6
// module chunks = 1